<p-dropdown
  [options]="languages"
  [ngModel]="selectedLanguageCode()"
  (onChange)="onLanguageChange($event.value)"
  optionLabel="name"
  optionValue="code"
  [style]="{ 'min-width': '150px' }"
>
  <ng-template pTemplate="selectedItem" let-selectedItem>
    <div class="flex align-items-center gap-2" *ngIf="selectedItem">
      <span>{{ selectedItem.flag }}</span>
      <span>{{ selectedItem.name }}</span>
    </div>
  </ng-template>
  <ng-template let-language pTemplate="item">
    <div class="flex align-items-center gap-2">
      <span>{{ language.flag }}</span>
      <span>{{ language.name }}</span>
    </div>
  </ng-template>
</p-dropdown>
